// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper___upxS","truncatedText":"styles_truncatedText__BQHgt","fullText":"styles_fullText__Ae5_5","textContainer":"styles_textContainer__pgXhb"};